<template>
  <base-echart
    :options="option"
    @legendselectchanged="handleLegendSelectChange"
  />
</template>

<script>
import { mapGetters } from 'vuex'

const colors = [
  '#ff7675', // red
  '#fdcb6e', // blue
  '#0984e3', // green
]

export default {
  props: [
    'items',
    'type',
    'selectedKey',
  ],

  computed: {
    ...mapGetters({
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
    }),
    products () {
      return this.items.reduce((acc, cur) => {
        cur.skus.map((item) => item.skuId).forEach((skuId) => {
          if (!acc.includes(skuId)) {
            acc.push(skuId)
          }
        })
        return acc
      }, [])
    },
    barChartLineChartOption () {
      const series = this.products.map((skuId, index) => {
        return {
          data: this.items.map((item) => {
            const result = item.skus.find((itemSku) => (
              itemSku.skuId === skuId
            ))
            return result ? result[this.selectedKey] : null
          }),
          type: this.type,
          stack: 'a',
          name: this.getProductFullNameBySkuId(skuId) || this.$t('apps.reports.message.unspecifiedproductname'),
          label: {
            show: true,
            formatter: (params) => [null, '-', 0].includes(params.value) ? '' : params.value,
          },
          color: colors[index],
        }
      })
      return {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          selectedMode: true,
          type: 'scroll',
        },
        xAxis: {
          type: 'category',
          data: this.items.map((item) => item.date),
        },
        yAxis: {
          type: 'value',
        },
        series: series,
      }
    },
    pieChartOption () {
      return {
        color: colors,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            label: {
              show: this.products.length <= 50,
              formatter (param) {
                return param.name + ' (' + param.percent + '%)'
              },
            },
            data: this.products.map((skuId) => {
              return {
                value: this.items.reduce((acc, cur) => {
                  const total = cur.skus.reduce((_acc, _cur) => {
                    if (_cur.skuId === skuId) {
                      _acc += _cur[this.selectedKey]
                    }
                    return _acc
                  }, 0)
                  return acc + total
                }, 0),
                name: this.getProductFullNameBySkuId(skuId) || this.$t('apps.reports.message.unspecifiedproductname'),
              }
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    option () {
      if (this.type === 'bar' || this.type === 'line') {
        return this.barChartLineChartOption
      }
      return this.pieChartOption
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

  <style scoped>
  .chart-container /deep/ .echarts {
    width: 100% !important;
  }
  </style>



// WEBPACK FOOTER //
// src/components/combine/ReportPosSkuChart.vue